import { useAuthStore } from '../../auth/auth.store';
/**
 * Returns a function that checks whether the current user holds a given permission.
 * Super admins always return true. Use for imperative checks inside component logic
 * (e.g. disabling a button, building conditional arrays). For JSX branching prefer
 * the <PermissionGate> component.
 *
 * @example
 * const can = usePermission();
 * const menuItems = allItems.filter(item => can(item.permission));
 */
export function usePermission() {
    const user = useAuthStore((s) => s.user);
    return (code) => {
        if (!user)
            return false;
        if (user.isSuperAdmin)
            return true;
        const codes = Array.isArray(code) ? code : [code];
        return codes.some((c) => user.permissions.includes(c));
    };
}
